import PropTypes from 'prop-types'

export const PromiseProp = PropTypes.shape({
  then: PropTypes.func.isRequired,
})

export const ImageProp = PropTypes.shape({
  src: PropTypes.string,
  alt: PropTypes.string,
})

export const SourceProp = PropTypes.shape({
  srcSet: PropTypes.string.isRequired,
  media: PropTypes.string,
})

export const MoneyProp = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
})



// WEBPACK FOOTER //
// ../source/utilities/propTypes.js